"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9012],{

/***/ 64557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var CalendarIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, dimension = _param.dimension, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "color",
        "dimension"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: dimension || 24,
        height: dimension || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.0625 11.1875C16.4077 11.1875 16.6875 10.9077 16.6875 10.5625C16.6875 10.2173 16.4077 9.9375 16.0625 9.9375C15.7173 9.9375 15.4375 10.2173 15.4375 10.5625C15.4375 10.9077 15.7173 11.1875 16.0625 11.1875Z",
                fill: color || "#9CA7B7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.5 5.25H16.6875V4.625C16.6875 4.27981 16.4077 4 16.0625 4C15.7173 4 15.4375 4.27981 15.4375 4.625V5.25H12.5938V4.625C12.5938 4.27981 12.3139 4 11.9688 4C11.6236 4 11.3438 4.27981 11.3438 4.625V5.25H8.53125V4.625C8.53125 4.27981 8.25144 4 7.90625 4C7.56106 4 7.28125 4.27981 7.28125 4.625V5.25H6.5C5.1215 5.25 4 6.3715 4 7.75V17.5C4 18.8785 5.1215 20 6.5 20H11.2812C11.6264 20 11.9062 19.7202 11.9062 19.375C11.9062 19.0298 11.6264 18.75 11.2812 18.75H6.5C5.81075 18.75 5.25 18.1892 5.25 17.5V7.75C5.25 7.06075 5.81075 6.5 6.5 6.5H7.28125V7.125C7.28125 7.47019 7.56106 7.75 7.90625 7.75C8.25144 7.75 8.53125 7.47019 8.53125 7.125V6.5H11.3438V7.125C11.3438 7.47019 11.6236 7.75 11.9688 7.75C12.3139 7.75 12.5938 7.47019 12.5938 7.125V6.5H15.4375V7.125C15.4375 7.47019 15.7173 7.75 16.0625 7.75C16.4077 7.75 16.6875 7.47019 16.6875 7.125V6.5H17.5C18.1892 6.5 18.75 7.06075 18.75 7.75V11.3125C18.75 11.6577 19.0298 11.9375 19.375 11.9375C19.7202 11.9375 20 11.6577 20 11.3125V7.75C20 6.3715 18.8785 5.25 17.5 5.25Z",
                fill: color || "#9CA7B7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.2188 12.4375C14.1337 12.4375 12.4375 14.1337 12.4375 16.2188C12.4375 18.3038 14.1337 20 16.2188 20C18.3038 20 20 18.3038 20 16.2188C20 14.1337 18.3038 12.4375 16.2188 12.4375ZM16.2188 18.75C14.823 18.75 13.6875 17.6145 13.6875 16.2188C13.6875 14.823 14.823 13.6875 16.2188 13.6875C17.6145 13.6875 18.75 14.823 18.75 16.2188C18.75 17.6145 17.6145 18.75 16.2188 18.75Z",
                fill: color || "#9CA7B7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.125 15.5938H16.8438V14.9375C16.8438 14.5923 16.5639 14.3125 16.2188 14.3125C15.8736 14.3125 15.5938 14.5923 15.5938 14.9375V16.2188C15.5938 16.5639 15.8736 16.8438 16.2188 16.8438H17.125C17.4702 16.8438 17.75 16.5639 17.75 16.2188C17.75 15.8736 17.4702 15.5938 17.125 15.5938Z",
                fill: color || "#9CA7B7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M13.3438 11.1875C13.6889 11.1875 13.9688 10.9077 13.9688 10.5625C13.9688 10.2173 13.6889 9.9375 13.3438 9.9375C12.9986 9.9375 12.7188 10.2173 12.7188 10.5625C12.7188 10.9077 12.9986 11.1875 13.3438 11.1875Z",
                fill: color || "#9CA7B7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.625 13.9062C10.9702 13.9062 11.25 13.6264 11.25 13.2812C11.25 12.9361 10.9702 12.6562 10.625 12.6562C10.2798 12.6562 10 12.9361 10 13.2812C10 13.6264 10.2798 13.9062 10.625 13.9062Z",
                fill: color || "#9CA7B7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.90625 11.1875C8.25143 11.1875 8.53125 10.9077 8.53125 10.5625C8.53125 10.2173 8.25143 9.9375 7.90625 9.9375C7.56107 9.9375 7.28125 10.2173 7.28125 10.5625C7.28125 10.9077 7.56107 11.1875 7.90625 11.1875Z",
                fill: color || "#9CA7B7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.90625 13.9062C8.25143 13.9062 8.53125 13.6264 8.53125 13.2812C8.53125 12.9361 8.25143 12.6562 7.90625 12.6562C7.56107 12.6562 7.28125 12.9361 7.28125 13.2812C7.28125 13.6264 7.56107 13.9062 7.90625 13.9062Z",
                fill: color || "#9CA7B7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.90625 16.625C8.25143 16.625 8.53125 16.3452 8.53125 16C8.53125 15.6548 8.25143 15.375 7.90625 15.375C7.56107 15.375 7.28125 15.6548 7.28125 16C7.28125 16.3452 7.56107 16.625 7.90625 16.625Z",
                fill: color || "#9CA7B7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.625 16.625C10.9702 16.625 11.25 16.3452 11.25 16C11.25 15.6548 10.9702 15.375 10.625 15.375C10.2798 15.375 10 15.6548 10 16C10 16.3452 10.2798 16.625 10.625 16.625Z",
                fill: color || "#9CA7B7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.625 11.1875C10.9702 11.1875 11.25 10.9077 11.25 10.5625C11.25 10.2173 10.9702 9.9375 10.625 9.9375C10.2798 9.9375 10 10.2173 10 10.5625C10 10.9077 10.2798 11.1875 10.625 11.1875Z",
                fill: color || "#9CA7B7"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CalendarIcon);


/***/ }),

/***/ 59012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_Favorite__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(36111);
/* harmony import */ var _mui_icons_material_FavoriteBorder__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(91811);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(99226);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(69661);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69368);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var _assets_Icons_CalendarIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64557);
/* harmony import */ var _constants_ProposalState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8573);
/* harmony import */ var _constants_UserType__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22898);
/* harmony import */ var _firebase_gig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30622);
/* harmony import */ var _firebase_user__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32012);
/* harmony import */ var _helper_dates__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18621);
/* harmony import */ var _helper_gigStates__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50481);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24849);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40570);
/* harmony import */ var _gigs_DataChip__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1582);
/* harmony import */ var _gigs_GigTimingsTitle__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48390);
/* harmony import */ var _GigStateTag__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99020);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97734);






















var GigCard = function(param) {
    var gig = param.gig, _gigStatusDisplay = param.gigStatusDisplay, gigStatusDisplay = _gigStatusDisplay === void 0 ? false : _gigStatusDisplay, gigState = param.gigState;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var gigStateValue = gig && (gigState ? gigState : gig.gigState);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), favourite = ref6[0], setFavourite = ref6[1];
    var ref7 = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.user.user;
    }), userUid = ref7.uid;
    var userType = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.user.user.userType;
    });
    var handleClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
            var proposalData;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!userUid) return [
                            3,
                            4
                        ];
                        if (!(userType === _constants_UserType__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Chef */ .Z.Chef && gig.gigId)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,_firebase_gig__WEBPACK_IMPORTED_MODULE_7__/* .fetchGigProposal */ .oP)(userUid, gig.gigId)
                        ];
                    case 1:
                        proposalData = _state.sent();
                        if (!proposalData.proposalState) {
                            router.push("/gig/".concat(gig.gigId, "/proposal/").concat(userUid));
                        }
                        if (!proposalData.proposalState || proposalData.proposalState === _constants_ProposalState__WEBPACK_IMPORTED_MODULE_5__/* ["default"].DRAFT */ .Z.DRAFT) {
                            router.push("/gig/".concat(gig.gigId, "/proposal/").concat(userUid));
                        } else {
                            router.push("/gigs/".concat(userUid, "/proposal-preview/").concat(gig.gigId));
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        if (gig.ownerUid === userUid) {
                            router.push("/gigs/".concat(userUid, "/all-proposal/").concat(gig.gigId));
                        } else {
                            router.push("/gig/".concat(gig.gigId, "/proposal/").concat(userUid));
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        router.push("/gig/".concat(gig.gigId));
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), gigOwnerProfileImage = ref8[0], setGigOwnerProfileImage = ref8[1];
    var setUserProfileImage = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
            var profileImage;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!gig.ownerUid) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,_firebase_user__WEBPACK_IMPORTED_MODULE_8__/* .fetchUserProfileImage */ .Es)(gig.ownerUid)
                        ];
                    case 1:
                        profileImage = _state.sent();
                        profileImage && setGigOwnerProfileImage(profileImage);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function setUserProfileImage() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isLiked = false;
        if (gig.likedBy && userUid && gig.likedBy.indexOf(userUid) > -1) {
            isLiked = true;
        }
        setFavourite(isLiked);
        setUserProfileImage();
    }, []);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var handleLikeDislike = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(e) {
            var favouriteData;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.stopPropagation();
                        favouriteData = !favourite;
                        setFavourite(favouriteData);
                        if (!userUid) {
                            return [
                                2,
                                router.push("/auth/login")
                            ];
                        }
                        if (!gig.gigId) return [
                            3,
                            4
                        ];
                        if (!(favouriteData === true)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,_firebase_user__WEBPACK_IMPORTED_MODULE_8__/* .addFavouriteGig */ .Qe)(userUid, gig.gigId)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            (0,_firebase_user__WEBPACK_IMPORTED_MODULE_8__/* .removeFavouriteGig */ .lC)(userUid, gig.gigId)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLikeDislike(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var startDate = (0,_helper_dates__WEBPACK_IMPORTED_MODULE_9__/* .getGigStartDate */ .Yw)(gig);
    var endDate = (0,_helper_dates__WEBPACK_IMPORTED_MODULE_9__/* .getGigEndDate */ .q1)(gig);
    var titleList = [
        {
            title: "Gig Created",
            date: (gig === null || gig === void 0 ? void 0 : gig.createdAt) ? (0,_helper_dates__WEBPACK_IMPORTED_MODULE_9__/* .convertDateFormat */ .fc)(gig === null || gig === void 0 ? void 0 : gig.createdAt) : " N/A"
        },
        {
            title: "Gig Start Date",
            date: startDate ? (0,_helper_dates__WEBPACK_IMPORTED_MODULE_9__/* .convertDateFormat */ .fc)(startDate) : "N/A"
        },
        {
            title: "Gig End Date",
            date: endDate ? (0,_helper_dates__WEBPACK_IMPORTED_MODULE_9__/* .convertDateFormat */ .fc)(endDate) : "N/A"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
        py: {
            xs: 1
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
            onClick: handleClick,
            sx: {
                p: {
                    xs: 3,
                    md: 4
                },
                cursor: "pointer",
                borderLeft: "4px solid ".concat((0,_helper_gigStates__WEBPACK_IMPORTED_MODULE_10__/* .getStateData */ .O)(gigStateValue).color)
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    sx: {
                        background: "".concat(gig && gig.headerImageUrl ? 'url("'.concat(gig.headerImageUrl, '")') : _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.grey2[100] */ .r.grey2[100]),
                        height: {
                            xs: "4rem",
                            md: "9.8rem"
                        },
                        width: "100%",
                        display: "flex",
                        alignItems: {
                            xs: "start",
                            md: "end"
                        },
                        justifyContent: "space-between",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        borderRadius: "0.375rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            sx: {
                                padding: 2
                            },
                            children: gigStateValue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GigStateTag__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                gigStateValue: gigStateValue
                            })
                        }),
                        (gig === null || gig === void 0 ? void 0 : gig.isPrivate) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            sx: {
                                alignSelf: "flex-start",
                                backgroundColor: "rgba(25, 17, 34, 0.75)",
                                color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.whiteBg.WBG1 */ .r.whiteBg.WBG1,
                                borderBottomLeftRadius: "8px",
                                px: 1.5,
                                py: 0.5,
                                fontSize: {
                                    xs: "0.65rem",
                                    md: "0.75rem"
                                },
                                fontWeight: 600,
                                textTransform: "uppercase",
                                letterSpacing: "0.08em"
                            },
                            children: "Private gig"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                    container: true,
                    sx: {
                        py: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "left"
                            },
                            item: true,
                            xs: 10,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    sx: {
                                        width: {
                                            md: "1.5rem"
                                        },
                                        height: {
                                            md: "1.5rem"
                                        },
                                        cursor: "pointer"
                                    },
                                    alt: "Profile image",
                                    // onClick={handleAvatarClick}
                                    src: gigOwnerProfileImage
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    variant: "title5",
                                    sx: {
                                        color: "".concat(_mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.black[800] */ .r.black[800], " !important"),
                                        marginLeft: "1em"
                                    },
                                    children: gig && gig.title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                            item: true,
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "right"
                            },
                            xs: 2,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                sx: {
                                    ml: "auto"
                                },
                                checked: favourite,
                                onChange: handleLikeDislike,
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_FavoriteBorder__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {}),
                                checkedIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Favorite__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                    sx: {
                                        color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.brand2[300] */ .r.brand2[300]
                                    }
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    sx: {
                        display: "flex"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            sx: {
                                flexGrow: "1"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                                sx: {
                                    mb: "1rem",
                                    display: "flex",
                                    alignItems: "flex-end",
                                    width: "100%"
                                },
                                container: true,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gigs_DataChip__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "Type of Service",
                                        data: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                variant: "small5",
                                                sx: {
                                                    color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.brand1[500] */ .r.brand1[500],
                                                    maxWidth: {
                                                        xs: "100px",
                                                        md: "130px"
                                                    },
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                },
                                                children: gig && gig.serviceType
                                            }, gig && gig.serviceType), 
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gigs_DataChip__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "Location",
                                        data: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                variant: "small5",
                                                sx: {
                                                    color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.brand1[500] */ .r.brand1[500],
                                                    maxWidth: {
                                                        xs: "60px",
                                                        md: "80px"
                                                    },
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                },
                                                children: (gig === null || gig === void 0 ? void 0 : (ref = gig.location) === null || ref === void 0 ? void 0 : ref.locality) && (gig === null || gig === void 0 ? void 0 : (ref1 = gig.location) === null || ref1 === void 0 ? void 0 : ref1.state) && "".concat((ref2 = gig.location) === null || ref2 === void 0 ? void 0 : ref2.locality, ", ").concat((ref3 = gig.location) === null || ref3 === void 0 ? void 0 : ref3.state)
                                            }, gig && "".concat((ref4 = gig.location) === null || ref4 === void 0 ? void 0 : ref4.locality, ", ").concat((ref5 = gig.location) === null || ref5 === void 0 ? void 0 : ref5.state)), 
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gigs_DataChip__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "Guests",
                                        data: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: gig && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                    variant: "small4",
                                                    sx: {
                                                        color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.brand1[500] */ .r.brand1[500],
                                                        maxWidth: {
                                                            xs: "40px",
                                                            md: "60px"
                                                        }
                                                    },
                                                    children: gig.numberOfGuests
                                                }, gig && "".concat(gig.numberOfGuests))
                                            }), 
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gigs_DataChip__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "Budget",
                                        data: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                variant: "small4",
                                                sx: {
                                                    color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.brand1[500] */ .r.brand1[500],
                                                    maxWidth: {
                                                        xs: "40px",
                                                        md: "60px"
                                                    }
                                                },
                                                children: "$".concat(gig === null || gig === void 0 ? void 0 : gig.budget)
                                            }, gig === null || gig === void 0 ? void 0 : gig.budget), 
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            sx: {
                                display: {
                                    xs: "none",
                                    md: "block"
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                sx: {
                                    width: {
                                        md: "200px"
                                    }
                                },
                                onClick: handleClick,
                                children: "View Details"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                    container: true,
                    sx: {
                        my: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 1,
                            sx: {
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "center",
                                mr: "1rem",
                                flexDirection: "column"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_Icons_CalendarIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    sx: {
                                        display: {
                                            lg: "none"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_Icons_CalendarIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                            container: true,
                            item: true,
                            xs: 10,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 12,
                                sx: {
                                    my: "1rem"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gigs_GigTimingsTitle__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    titleList: titleList
                                })
                            })
                        })
                    ]
                }),
                gigStateValue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    sx: {
                        display: {
                            xs: "flex",
                            md: "none"
                        },
                        justifyContent: "center",
                        "& button": {
                            width: "100% !important"
                        }
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        sx: {
                            width: {
                                md: "200px"
                            }
                        },
                        onClick: handleClick,
                        children: "View Details"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GigCard);


/***/ }),

/***/ 1582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99226);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86886);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24849);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97734);









var DataChip = function(_param) {
    var title = _param.title, data = _param.data, sx = _param.sx, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "title",
        "data",
        "sx"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        item: true,
        sx: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
        }
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            sx: sx,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    sx: {
                        color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.grey2[500] */ .r.grey2[500]
                    },
                    variant: "small5",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    sx: {
                        mt: "0.5rem",
                        display: "flex",
                        flexDirection: "row"
                    },
                    children: data.map(function(Data, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            sx: {
                                backgroundColor: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.brand1[50] */ .r.brand1[50],
                                borderRadius: "0.375rem",
                                mr: "0.5rem",
                                py: "0.25rem",
                                px: "0.5rem"
                            },
                            children: Data
                        }, index);
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DataChip);


/***/ }),

/***/ 48390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86886);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99226);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24849);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97734);





var GigTimingsTitle = function(param) {
    var titleList = param.titleList;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        container: true,
        spacing: 2,
        children: titleList.map(function(data) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                item: true,
                xs: 4,
                lg: 2,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    sx: {
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "column",
                        height: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            sx: {
                                color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.grey2[500] */ .r.grey2[500],
                                mb: "8px"
                            },
                            variant: "small5",
                            children: data.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            variant: "small4",
                            children: data.date || "n/a"
                        })
                    ]
                })
            }, data.title);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GigTimingsTitle);


/***/ })

}]);